import { Link } from 'react-router-dom';
import MangaCard from '@/components/base/MangaCard';
import { hotRecommendations } from '@/mocks/comics';

export default function HotRecommend() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">每日精选优质漫画，不容错过</p>
        </div>
        <Link
          to="/ranking"
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5" data-product-shop>
        {hotRecommendations.slice(0, 10).map((manga) => (
          <MangaCard key={manga.id} manga={manga} />
        ))}
      </div>

      <div className="mt-6 text-center sm:hidden">
        <Link
          to="/ranking"
          className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium cursor-pointer"
        >
          查看更多热门推荐 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}